// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const iron_moth: PokeData = {
  "id": 994,
  "name": "iron-moth",
  "height": 12,
  "weight": 360,
  "base_experience": 285,
  "types": [
    PokeType.FIRE,
    PokeType.POISON
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "take-down",
    "ember",
    "fire-spin",
    "screech",
    "morning-sun",
    "overheat",
    "metal-sound",
    "bug-buzz",
    "discharge",
    "sludge-wave",
    "acid-spray",
    "struggle-bug",
    "hurricane",
    "fiery-dance",
    "lunge"
  ],
  "moves": [
    "gust",
    "ember",
    "fire-spin",
    "morning-sun",
    "metal-sound",
    "bug-buzz",
    "hurricane",
    "lunge",
    "venom-drench",
    "flare-blitz",
    "sludge-bomb",
    "fire-ball",
    "toxic-overload"
  ],
  "evolution_chain": {
    "id": 525,
    "item": null,
    "species": [
      {
        "name": "iron-moth",
        "order": 988,
        "types": [
          PokeType.FIRE,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 99,
    "speed": 132,
    "ability_power": 168
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
